module.exports = __webpack_public_path__ + "img/Auto Rejected.147ab76c.png";